export const contactDetails = {
    addressLine1: 'swipejobs, Inc.',
    addressLine2: '3824 Cedar Springs Rd',
    addressLine3: '#801-3091',
    addressLine4: 'Dallas, Texas 75219'
}
